"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapSkillToEquipment = {
    'interior.1': ['14-24mmFullFrameOr10-16CropSensor'],
    'interior.3': ['14-20mmFullFrame'],
    'interior.5': ['14-20mmFullFrame'],
    'exterior.1': ['14-24mmFullFrameOr10-16CropSensor'],
    'exterior.3': ['14-20mmFullFrame'],
    'exterior.5': ['20mmFullFrame'],
    'drone.1': ['12MP+Drone', 'UAVLicense', 'droneWorkAccidentLiabilityInsurance'],
    'drone.3': ['20MP+Drone', 'UAVLicense', 'droneWorkAccidentLiabilityInsurance'],
    'drone.5': ['32MP+Drone', 'UAVLicense', 'droneWorkAccidentLiabilityInsurance'],
    'treesixty.1': ['matterportCompatibleCamera'],
    'treesixty.3': ['ricoThetaZ1'],
    'treesixty.5': ['matterportPro2OrLeicaBLK360'],
    'food.1': ['35mm+CropOrFullFrame'],
    'food.3': ['35mm+CropOrFullFrame'],
    'food.5': ['F2.8+Lens90Tripod15-30mmFullFrame'],
    'floorplan.1': ['magicPlan'],
    'floorplan.3': ['magicPlan'],
    'floorplan.5': ['magicPlan'],
    'portrait.1': [],
    'portrait.3': []
};
exports.default = mapSkillToEquipment;
//# sourceMappingURL=equipmentBySkills.js.map